
export default {

    stockists(state,data){
        state.stockists = data
    },

    stockist(state,data){
        state.stockist = data
    },

    rebateEarnings(state,data){
         state.rebateEarnings = data
    },

    stockistsStats(state,data){
        state.stockistsStats = data
    },

    stockistsOrders(state,data){
         state.sotckistsOrders = data
    },

    stockistsAction(state,data){
        state.stockistsAction = data
    },

    stockistsState(state,data){
        state.stockistsState = data
    },
    stockistsCurrentPage(state,data){
        state.stockistsCurrentPage = data
    },
    stockistsLastPage(state,data){
        state.stockistsLastPage = data
    },
    stockistsPerPage(state,data){
         state.stockistsPerPage = data
    },
    stockistsTotalPages(state,data){
         state.stockistsTotalPages = data
    },

    stockistsOrdersAction(state,data){
        state.stockistsOrdersAction = data
    },

    stockistsOrdersState(state,data){
        state.stockistsOrdersState = data
    },
    stockistsOrdersCurrentPage(state,data){
        state.stockistsOrdersCurrentPage = data
    },
    stockistsOrdersLastPage(state,data){
        state.stockistsOrdersLastPage = data
    },
    stockistsOrdersPerPage(state,data){
         state.stockistsOrdersPerPage = data
    },
    
    stockistsOrdersTotalPages(state,data){
        state.stockistsOrdersTotalPages = data
    },

    stockistUpgrades(state,data){
         state.stockistUpgrades = data
    },

    stockistUpgradesAction(state,data){
         state.stockistUpgradesAction = data
    },

    stockistUpgradesState(state,data){
         state.stockistUpgradesState = data
    },
    stockistUpgradesCurrentPage(state,data){
        state.stockistUpgradesCurrentPage = data
    },
    stockistUpgradesLastPage(state,data){
        state.stockistUpgradesLastPage = data
    },
    stockistUpgradesPerPage(state,data){
        state.stockistUpgradesPerPage = data
    },
    stockistUpgradesTotalPages(state,data){
        state.stockistUpgradesTotalPages = data
    },
}